
import { css } from 'lit';
export default css`
.hr {

  border-bottom: none;
  width: 100%;
}

  .hr--color--black {
      border-color: black;
    }

  .hr--color--light-outline-gray {

  --tw-border-opacity: 1;

  border-color: rgba(216, 216, 216, var(--tw-border-opacity));
}

  .hr--height--1 {
      border-top-width: 1px;
    }

  .hr--height--2 {
      border-top-width: 2px;
    }

  .hr--height--3 {
      border-top-width: 3px;
    }

  .hr--height--4 {
      border-top-width: 4px;
    }

  .hr--height--5 {
      border-top-width: 5px;
    }

  .hr--height--6 {
      border-top-width: 6px;
    }

  .hr--height--7 {
      border-top-width: 7px;
    }

  .hr--height--8 {
      border-top-width: 8px;
    }

  .hr--height--9 {
      border-top-width: 9px;
    }

  .hr--height--10 {
      border-top-width: 10px;
    }

  .hr--injected-variant--location-ct {
        display: none;
    }

  @media (min-width: 1200px) {

  .hr--injected-variant--location-ct {
      display: block
    }
      }


`;